module.exports = __webpack_public_path__ + "img/ellipses.73d3b7a5.svg";